import { OPEN_SUPPORT, CLOSE_SUPPORT } from "../constants/ActionTypes";

const support = (state = { open: false }, action) => {
  switch (action.type) {
    case OPEN_SUPPORT:
      return { open: true };
    case CLOSE_SUPPORT:
      return { open: false};
    default:
      return state;
  }
};

export default support;
